import * as yup from "yup";

export const csvUploadSchema = yup.object().shape({
  csvFile: yup.mixed()
    .required("You need to provide a file")
    .test("fileSize", "The file is too large and must be less than 2MB", (file) => {
      return file && (file as HTMLInputElement).size <= 2000000;
    })
});
